import { Lookup, useLookup } from '@/providers'
import { Autocomplete, TextField } from '@mui/material'
import { UrlUpdateType } from 'use-query-params'

type Props = {
	value: number | null
	updateFilters: (changes: any, updateTypeOverride?: UrlUpdateType) => void
}

// FIXME: This file gets removed when 'feature-art-1534-brandtype-filter-update' is removed
export default function BrandOwner({ value, updateFilters }: Props) {
	const options = useLookup(Lookup.BrandOwner)

	const selectedValues = options.find((v) => v.id === value) || null

	const handleChange = (e, value) => {
		if (value) {
			updateFilters({ brandOwner: value.id })
		} else {
			updateFilters({ brandOwner: '' })
		}
	}

	return (
		<Autocomplete
			fullWidth
			size="small"
			options={options}
			value={selectedValues}
			onChange={handleChange}
			renderInput={(params) => <TextField {...params} label="Brand Type" />}
			slotProps={{ paper: { style: { width: '24rem' } } }}
		/>
	)
}
